<div
    [attr.data-uitype]="'card'"
    [class.hidden]="!showCard()"
    class="dat-border-card rounded-md bg-white m-6 py-2 px-4"
>
    <header>
        <h3 class="title-large-strong">{{ title() }}</h3>
    </header>
    <main>
        <div
            #diagramContainer
            class="w-full h-full max-h-[600px] overflow-x-hidden overflow-y-scroll"
        ></div>
    </main>
</div>
